import React, { useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import 'alertifyjs/build/css/themes/default.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Header from '../../layout/header';
import Footer from '../../layout/footer';
import * as XLSX from 'xlsx';

const useStyles = makeStyles({
    root: {
        width: '100%',
        marginTop: '20px',
        padding: '20px',
    },
    container: {
        maxHeight: 600,
        overflowY: 'auto',
        border: '1px solid #ccc',
        borderRadius: '5px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '7px',
    },
    logo: {
        width: '70px',
    },
    title: {
        fontSize: '40px !important',
        fontWeight: 'bold',
        textAlign: 'center',
        flexGrow: 1,
    },
    buttonGroup: {
        display: 'flex',
        gap: '10px',
    },
    button: {
        fontSize: '14px',
    },
});

export default function BusinessDashboard(props) {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [positions, setPositions] = React.useState([]);
    const [pagination, setPagination] = React.useState({});
    const history = useHistory();

    useEffect(() => {
        getUserData();
    }, [page]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const getUserData = async () => {
        const { data } = await axios.get(`/positions/getAllShop?page=${page + 1}`);
        const finalPositions = data.data;
        const paginationData = data.pagination;
        setPositions(finalPositions);
        setPagination(paginationData);
    };

    const downloadPdf = async () => {
        try {
            const { data } = await axios.get(`/positions/getAllShop?page=${page + 1}&&pageSize=5000`);
            const finalPositions = data.data;
            const worksheet = XLSX.utils.json_to_sheet(finalPositions);
        
            // Create a new workbook and add the worksheet
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'User Data');

            // Export the workbook to an Excel file
            XLSX.writeFile(workbook, 'UserData.xlsx');
            
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
         <Header/>

        <Paper className={classes.root}>
           
            {/* Header Section */}
            <div className={classes.header}>
                <h1 className={classes.title}>PERFORMANCE LIST</h1>
                <div className={classes.buttonGroup}>

                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        onClick={() => downloadPdf()}
                    >
                        Download XLSX
                     </Button>
                </div>
            </div>

            {/* Table Section */}
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {[
                                'Symbol', 'Ticker', 'Type', 'Date', 'Open Time', 'Close Time',
                                "End Date", "Market Open Position Price", "BUY/SELL", "Stop Loss",
                                "SUCCEED", "Pips", "TP1", "TP2", "TP3", "TP4", "TP5","Position Id"
                            ].map((label, idx) => (
                                <TableCell key={idx} align="center">
                                    {label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {positions.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell align="center">{row.symbol}</TableCell>
                                <TableCell align="center">{row.ticker}</TableCell>
                                <TableCell align="center">{row.type}</TableCell>
                                <TableCell align="center">{row.date}</TableCell>
                                <TableCell align="center">{row.openTime}</TableCell>
                                <TableCell align="center">{row.closeTime}</TableCell>
                                <TableCell align="center">{row.endDate}</TableCell>
                                <TableCell align="center">{row.marketOpenPositionPrice}</TableCell>
                                <TableCell align="center">{row.buySell}</TableCell>
                                <TableCell align="center">{row.stopLossPrice}</TableCell>
                                <TableCell align="center">{row.succeeded}</TableCell>
                                <TableCell align="center">{row.pips}</TableCell>
                                <TableCell align="center">{row.takeProfit1}</TableCell>
                                <TableCell align="center">{row.takeProfit2}</TableCell>
                                <TableCell align="center">{row.takeProfit3}</TableCell>
                                <TableCell align="center">{row.takeProfit4}</TableCell>
                                <TableCell align="center">{row.takeProfit5}</TableCell>
                                <TableCell align="center">{row.positionId}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </TableContainer>

            {/* Pagination */}
            <TablePagination
                rowsPerPageOptions={[10]}
                component="div"
                count={pagination.totalPages}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
            />
        </Paper>

        <Footer/>
        </>
    );
}
